import React, { useState } from 'react'
import useExperiencePlayerLaunch from 'hooks/useExperiencePlayerLaunch'
import ExperiencePlayerTestComponent from './component'

const DEFAULT_LESSON_ID =
  'grade-10-activity-5-community-commitments-raw-C1OLULPy'

const ExperiencePlayerTestContainer = () => {
  const [lessonIdInput, setLessonIdInput] = useState(DEFAULT_LESSON_ID)
  const [activeLessonId, setActiveLessonId] = useState(DEFAULT_LESSON_ID)

  const {
    link,
    isCreating,
    isExpired,
    error,
    generateLink,
    timeUntilExpiry,
  } = useExperiencePlayerLaunch({ lessonId: activeLessonId })

  const handleGenerate = () => {
    setActiveLessonId(lessonIdInput)
    generateLink({ lessonId: lessonIdInput })
  }

  const handleLessonIdChange = e => {
    setLessonIdInput(e.target.value)
  }

  return (
    <ExperiencePlayerTestComponent
      error={error}
      isCreating={isCreating}
      isExpired={isExpired}
      lessonIdInput={lessonIdInput}
      link={link}
      onGenerate={handleGenerate}
      onLessonIdChange={handleLessonIdChange}
      timeUntilExpiry={timeUntilExpiry}
    />
  )
}

export default ExperiencePlayerTestContainer
